import Link from 'next/link';
import {ReactNode} from 'react';
import {SchemeLink} from '../../../applink/SchemeLink';
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';

export function FooterMenuItem({
  useKakaoenterPage,
  isMobile,
  emphasis,
  href,
  scheme,
  title,
}: {
  isMobile: boolean;
  useKakaoenterPage: boolean;
  href: string;
  scheme?: string;
  emphasis: boolean;
  title: string;
}) {
  return (
    <WrapperLink
      href={href}
      useKakaoenterPage={useKakaoenterPage}
      scheme={scheme}
    >
      <Text
        className={twMerge(
          isMobile
            ? 'font-small1 block cursor-pointer text-theme-solid-100'
            : 'font-medium2 cursor-pointer text-theme-solid-100',
          emphasis && (isMobile ? 'font-small1-bold' : 'font-medium2-bold')
        )}
      >
        {title}
      </Text>
    </WrapperLink>
  );
}

function WrapperLink({
  useKakaoenterPage,
  href,
  scheme,
  children,
}: {
  useKakaoenterPage: boolean;
  href: string;
  scheme?: string;
  children: ReactNode;
}) {
  return useKakaoenterPage && requestContext.requestInfo.display.isWebView ? (
    <SchemeLink scheme={scheme}>{children}</SchemeLink>
  ) : (
    <Link
      href={href}
      prefetch={false}
      target={href.startsWith('/') ? undefined : '_blank'}
      rel="noopener noreferrer"
    >
      {children}
    </Link>
  );
}
